import React, { useState } from 'react';
import { Box, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { Title } from '../../../../components/atoms/title';

export const SearchUbaby = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedMonth, setSelectedMonth] = useState(DateTime.now().startOf('month').toISODate());

  const getLast12Months = () => {
    const months = [];
    for (let i = 0; i < 12; i += 1) {
      const date = DateTime.now().minus({ months: i }).startOf('month');
      months.push({
        value: date.toISODate(),
        label: date.toFormat('MMMM yyyy'),
      });
    }
    return months;
  };

  const handlePhoneNumberChange = e => {
    const sanitizedValue = e.target.value.replace(/[^\d]/g, '');
    setPhoneNumber(sanitizedValue);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    navigate(`/ubaby-details/${phoneNumber}/${selectedMonth}`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title>Buscar Ubaby</Title>
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label='Phone Number'
            placeholder='55119999999999'
            fullWidth
            variant='outlined'
            onChange={handlePhoneNumberChange}
            value={phoneNumber}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id='month-select-label'>Month</InputLabel>
            <Select
              labelId='month-select-label'
              value={selectedMonth}
              label='Month'
              onChange={e => setSelectedMonth(e.target.value)}
            >
              {getLast12Months().map(month => (
                <MenuItem key={month.value} value={month.value}>
                  {month.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid container spacing={1} item>
          <Box m='auto' mt={3}>
            <Button variant='contained' color='primary' type='submit'>
              Procurar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
};
